<template>
    <div class="container66 mt-4" v-if="mainElement != null">
        <div :style="inverted ? '-webkit-transform: scaleX(-1);  transform: scaleX(-1);' :''">
            <!-- bandeja -->
            <img
                :src="require('@/assets/images/gamas/66/bandeja.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:' +
                        topPositionBandejaTapaTabiques + 'px; ' +
                        'left: ' + leftPositionImageRight + 'px;' +
                        'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />
            <!-- soporte horizontal directo pared -->
            <img
                v-if="withSoporteHorizontalDirectoPared"
                :src="require('@/assets/images/gamas/66/soporte_horizontal_directo_pared.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:0px; ' +
                        'left: ' + leftPositionImageRight + 'px;' +
                        'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />
            <!-- soporte horizontal -->
            <img
                v-if="withSoporteHorizontal"
                :src="require('@/assets/images/gamas/66/soporte_horizontal.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:0px; ' +
                        'left: ' + leftPositionImageRight + 'px;' +
                        'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />

            <!-- soporte vertical -->
            <img
                v-if="withSoporteVertical"
                :src="require('@/assets/images/gamas/66/soporte_vertical.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:0px;' +
                    'left: ' + leftPositionImageRight + 'px;' +
                    'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />

            <!-- soporte separador -->
            <img
                v-if="withSoporteSeparador"
                :src="require('@/assets/images/gamas/66/separador_suelo.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:0px;' +
                    'left: ' + leftPositionImageRight + 'px;'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />
            <!-- soporte trapecio -->
            <img
                v-if="withSoporteTrapecio"
                :src="require('@/assets/images/gamas/66/trapezio.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:0px;' +
                    'left: ' + leftPositionImageRight + 'px;'"
                :id="'img_bandeja_numbandeja'"
                :ref="'img_bandeja_numbandeja'"
                class="simetrica"
            />
            <!-- tapa -->
            <img
                v-if="mostrarTapa"
                :src="require('@/assets/images/gamas/66/tapa.png')"
                alt
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:' +
                    topPositionBandejaTapaTabiques + 'px; ' +
                    'left: ' + leftPositionImageRight + 'px;' +
                    'transform: rotate(' + rotacioBandeja + 'deg)'"
                v-show="mostrarTapa(mainElement)"
                :id="'img_tapa_numbandeja'"
                :ref="'img_tapa_numbandeja'"
                class="simetrica"
            />
            <!-- 1 tabiques  -->
            <img
                :src="require('@/assets/images/gamas/66/compartimentos2.png')"
                alt
                v-show="mostrarCompartimento(mainElement,2)"
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:' +
                        topPositionBandejaTapaTabiques + 'px; ' +
                        'left: ' + leftPositionImageRight + 'px;' +
                        'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_tabiques_numbandeja'"
                :ref="'img_tabiques_numbandeja'"
                class="simetrica"
            />
            <!-- 2 tabiques  -->
            <img
                :src="require('@/assets/images/gamas/66/compartimentos3.png')"
                alt
                v-show="mostrarCompartimento(mainElement,3)"
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:' +
                    topPositionBandejaTapaTabiques + 'px; ' +
                    'left: ' + leftPositionImageRight + 'px;' +
                    'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_tabiques_numbandeja'"
                :ref="'img_tabiques_numbandeja'"
                class="simetrica"
            />
            <!-- 3 tabiques  -->
            <img
                :src="require('@/assets/images/gamas/66/compartimentos4.png')"
                alt
                v-show="mostrarCompartimento(mainElement,4)"
                :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px; position: absolute; top:' +
                    topPositionBandejaTapaTabiques + 'px; ' +
                    'left: ' + leftPositionImageRight + 'px;' +
                    'transform: rotate(' + rotacioBandeja + 'deg)'"
                :id="'img_tabiques_numbandeja'"
                :ref="'img_tabiques_numbandeja'"
                class="simetrica"
            />

        </div>
    </div>
</template>

<style lang="scss">
.bandeja-66-item-dimensiones {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
}
.img66 {
    position: absolute;
    top: 0;
    left: -38px;
    height: 200px;
    width: 200px;
    position: absolute;
    overflow: hidden;
}

.container66 {
    height: 200px;
    width: 200px;
    position: relative;
}
</style>

<script>
import jQuery from "jquery";
import Vue from "vue";
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import mainElementsGenericComponent from "./mainElementsGeneric.vue";
import mainElement66Component from "./mainElement66.vue";
import mainElement66EditParametersComponent from "./mainElement66EditParameters.vue";

export default {
    extends: mainElementsGenericComponent,
    name: "mainElements66ImagesComponent",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true,
            bandejas: {},
            buttonsLoading: [],
            solConstructiva: "",
            window: { width: 0, height: 0 },
            elementSelected: null,
        };
    },
    components: {
        editParameterValueComponent,
        mainElementsGenericComponent,
        mainElement66EditParametersComponent,
        mainElement66Component,
    },
    props: {
        prop_readonly: false,
        mainElement: null,
        inverted: false
    },

    created() {
        this.solConstructiva = this.app.currentConfiguration.familyParameters[
            "sol_constructiva"
        ].value;

        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        showProposedDistance: function () {
            if (
                app.currentConfiguration.metadata &&
                app.currentConfiguration.metadata.distance_supports_proposed &&
                app.currentConfiguration.metadata.distance_supports_proposed !==
                    "n/a"
            ) {
                return true;
            }
            return false;
        },
        showDeleteButton: function () {
            return (
                Object.keys(app.currentConfiguration.mainElementParameters)
                    .length > 1
            );
        },
        showMultilevel: function () {
            return false;
        },
        imgSize: function () {
            if (this.isMobile) {
                return 175;
            }
            return 200;
        },
        rotacioTerra: function () {
            if (this.withSoportajeCliente) return 0;
            if (this.isWall) return 0;
            if (this.isFloor) return -90;
            if (this.isCeiling) return 90;
            return 0;
        },
        rotacioBandeja: function () {
            if (this.withSoportajeCliente) return 0;
            if (this.isWall && this.fijadaDirectamente) return 90;
            if (this.isWall && this.withSoporteVertical) return 90;
            return 0;
        },
        leftPositionImageLeft: function () {
            //desktop
            if (!this.isMobile) {
                return 29;
                //mobile
            } else {
                return 25;
            }
        },
        leftPositionImageRight: function () {
            //mobile
            if (this.isMobile) {
                if (this.isWall && this.withSoporteVertical) return -22;
                if (this.isWall && this.fijadaDirectamente) return -27;

                //desktop
            } else {
                if (this.isWall && this.fijadaDirectamente) return -27;
                return 0;
            }

            return 0;
        },

        leftPositionTerra: function () {
            if (this.isMobile) {
                if (this.isWall && this.fijadaDirectamente) return 40;
                if (this.isWall && this.withSoporteVertical) return 20;
                if (this.isWall && this.withSoporteHorizontalDirectoPared)
                    return 8;
                if (this.isWall && this.withPerfil) return 8;

            } else {
                if (this.fijadaDirectamente && this.isWall) return 30;
                if (this.fijadaDirectamente && this.isFloor) return 0;
                if (this.fijadaDirectamente && this.isCeiling) return -20;

                if (
                    this.isWall &&
                    this.withPerfil &&
                    this.withSoporteHorizontal
                )
                    return 9;

                if (this.isWall && this.withSoporteVertical) return 48;
                if (this.isWall && this.withSoporteHorizontalDirectoPared)
                    return 10;
            }

            return 0;
        },
        topPositionTerra: function () {
            if (this.isMobile) {
                if (this.fijadaDirectamente && this.isFloor) return -67;
                if (this.isCeiling && this.withPerfil) return -17;
                if (this.withSoporteTrapecio) return -17;
                if (this.withSoporteSeparador) return -59;
            } else {
                if (this.fijadaDirectamente && this.isWall) return 0;
                if (this.fijadaDirectamente && this.isCeiling) return 0;
                if (this.fijadaDirectamente && this.isFloor) return -77;

                if (this.isFloor && this.withSoporteSeparador) return -68;

                if (this.isCeiling && this.withPerfil) return -19;
                if (this.isCeiling && this.withSoporteTrapecio) return -19;
            }
            return 0;
        },
        topPositionBandejaTapaTabiques: function () {
            if (this.isMobile) {
                if (this.withSoporteTrapecio) {
                    return 75;
                } else {
                    return 0;
                }
            } else {
                if (this.withSoporteTrapecio) {
                    return 86;
                } else {
                    return 0;
                }
            }
            return 0;
        },
        isWall: function () {
            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-p")) return true;

            return false;
        },
        isFloor: function () {
            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-s")) return true;

            return false;
        },
        isCeiling: function () {
            var parent_id = this.solConstructiva.parent_id;

            if (parent_id.includes("10-t")) return true;

            return false;
        },
        withPerfil: function () {
            if (this.solConstructiva.id.includes("per")) return true;
            if (this.solConstructiva.id === "10-t_sop") return true;
            return false;
        },
        withPerfilDirectoAPared: function () {
            if (
                this.solConstructiva.id === "10-p_sh_per-h" ||
                this.solConstructiva.id === "10-p_sh_per-v"
            )
                return true;
            return false;
        },
        fijadaDirectamente: function () {
            if (
                this.solConstructiva.id === "10-p_dir" ||
                this.solConstructiva.id === "10-s_dir"
            )
                return true;
            return false;
        },
        withSoportajeCliente: function () {
            if (this.solConstructiva.id === "10-cliente") return true;

            return false;
        },
        withSoporteHorizontal: function () {
            if (this.solConstructiva.id === "10-t_sop") return true;
            if (this.solConstructiva.id === "10-p_sh_per-h") return true;
            if (this.solConstructiva.id === "10-p_sh_per-v") return true;
        },
        withSoporteHorizontalDirectoPared: function () {
            if (this.solConstructiva.id === "10-p_sh_dir-h") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-v") return true;
        },
        withSoporteVertical: function () {
            if (this.solConstructiva.id.includes("sv")) return true;
        },
        withSoporteTrapecio: function () {
            if (this.solConstructiva.id === "10-t_tra") return true;
        },
        withSoporteSeparador: function () {
            if (this.solConstructiva.id === "10-s_sep") return true;
        },
        direccionHorizontal: function () {
            if (this.isMobile) return false;

            if (
                this.solConstructiva.id.includes("-h") &&
                !this.solConstructiva.id === "10-p_sh_dir-h"
            )
                return true;

            if (
                this.solConstructiva.id === "10-s_dir" ||
                this.solConstructiva.id === "10-s_sep"
            )
                return true;

            return false;
        },
        direccionVertical: function () {
            if (this.solConstructiva.id.includes("-v")) return true;
            if (this.solConstructiva.id === "10-t_tra") return true;
            if (this.solConstructiva.id === "10-p_dir") return true; //ok
            if (this.solConstructiva.id === "10-p_sv") return true; //ok
            if (this.solConstructiva.id === "10-t_sop") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-h") return true;
            if (this.solConstructiva.id === "10-p_sh_per-h") return true;
            if (this.solConstructiva.id === "10-s_dir" && this.isMobile)
                return true;
            if (this.solConstructiva.id === "10-cliente") return true;

            return false;
        },
        growRight: function () {
            if (this.isMobile) {
                return false;
            } else {
                if (
                    this.direccionHorizontal &&
                    this.solConstructiva.id === "10-t_tra"
                )
                    return true;
                if (this.fijadaDirectamente && this.isFloor) return true;
                if (this.withSoporteSeparador && this.isFloor) return true;
            }

            return false;
        },
        growLeft: function () {
            //no posar res aqui
            if (this.direccionHorizontal && !this.growRight) return true;
            return false;
        },
        growUp: function () {
            return false;
        },
        growDown: function () {
            if (this.direccionVertical && this.solConstructiva.id === "10-p_sv")
                return true; //ok
            if (this.solConstructiva.id === "10-p_dir") return true; //ok
            if (this.solConstructiva.id === "10-t_sop") return true; //ok
            if (this.solConstructiva.id === "10-t_tra") return true; //ok
            if (this.solConstructiva.id === "10-p_sh_dir-h") return true;
            if (this.solConstructiva.id === "10-p_sh_dir-v") return true;
            if (this.solConstructiva.id === "10-p_sh_per-h") return true;
            if (this.solConstructiva.id === "10-p_sh_per-v") return true;
            if (this.solConstructiva.id === "10-cliente") return true;
            if (this.solConstructiva.id === "10-s_dir" && this.isMobile)
                return true;
            if (this.solConstructiva.id === "10-s_sep" && this.isMobile)
                return true;

            return false;
        },

        isMobile: function () {
            let a = this.window.width < 750;
            return a;
        },
        isMobile_xs: function () {
            let a = this.window.width < 350;
            return a;
        },
        isMobile_lg: function () {
            let a = this.window.width > 500 && this.isMobile;
            return a;
        },
        isTablet: function () {
            let a = this.window.width < 800;
            return a;
        },
        width_params: function () {
            if (this.isMobile) {
                return "200px";
            } else if (this.direccionHorizontal) {
                return "160px";
            } else {
                return "160px";
            }
        },
        //wallrotation
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
        },

        mostrarTapa: function (mainElementParameters) {
            if (
                mainElementParameters["opcion_tapa"].value == "" ||
                mainElementParameters["opcion_tapa"].value.id == "n"
            ) {
                // Ocultar imagen Tapa si no hay nada seleccionado
                // o se ha seleccionado sin tapa
                return false;
            } else if (mainElementParameters["opcion_tapa"].value.id == "s") {
                // Mostrar imagen Tapa
                return true;
            }
            return false;
        },
        mostrarCompartimento: function (
            mainElementParameters,
            numCompartimentos
        ) {
            var numeroCompartimentosSeleccionados = 0;

            if (mainElementParameters["opcion_compartimento"].value == "") {
                // Ocultar imagen Tapa si no hay nada seleccionado
                // o se ha seleccionado sin tapa
                return false;
            } else {
                numeroCompartimentosSeleccionados =
                    mainElementParameters["opcion_compartimento"].value
                        .num_value;
                if (numCompartimentos == numeroCompartimentosSeleccionados) {
                    return true;
                }
            }

            return false;
        },
    },
    beforeMount() {
        this.bandejas = app.currentConfiguration.mainElementParameters;
    },
    mounted() {
        this.$emit("ishorizontal", this.direccionHorizontal);
    },
};
</script>

